<template>
    <div class="burger-content-modal">
        <div class="p-2">
            <v-btn
                    class="big-close-btn burger-content-modal__close"
                    fab
                    color="#ececd8"
                    @click="closeModal"
            >
                <v-icon aria-label="Close" large>
                    mdi-close
                </v-icon>
            </v-btn>
            <div class="burger-content-modal__content">
                <template v-if="type === 'text'">
                    <div class="burger-content-modal__text" v-html="content"></div>
                </template>

                <template v-if="type === 'audio'">
                    <audio controls ref="audio">
                        <source :src="content">
                    </audio>
                </template>

                <template v-if="type === 'youtube'">
                    <iframe width="720" height="576" :src="`${content}?autoplay=1`" frameborder="0" allowfullscreen ref="youtube"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
                </template>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'BurgerContentModal',
        props: {
            type: {
                type: String
            },
            content: {
                type: String
            }
        },
        mounted() {
          if (this.type === 'audio') {
              this.$nextTick(()=>{
                  this.$refs.audio.play()
              })
          }
        },
        methods: {
            closeModal() {
                this.$emit('close')
            },
        },
    }
</script>

<style scoped lang="scss">
    .burger-content-modal {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: auto;
        &__close {
            position: absolute;
            top: 0;
            right: 0;
        }
    }
</style>
